import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FuzzyActions } from 'actions';
import SelectFuzzy from 'containers/components/Fields/SelectFuzzy';
import { getLiteral } from 'utils/getLiteral';

const CampaignDetailAccountFilter = memo(({ idCampaign, onChange }) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState();

    const handleChange = useCallback(
        (selected) => {
            let nextValue;
            if (selected == null || selected === '') {
                nextValue = undefined;
            } else if (typeof selected === 'object') {
                nextValue = selected;
            } else {
                nextValue = { value: selected, label: String(selected) };
            }

            setValue(nextValue);

            const accountId =
                nextValue?.value != null && nextValue?.value !== ''
                    ? parseInt(nextValue.value, 10)
                    : null;
            onChange?.(accountId);
        },
        [onChange],
    );

    const fetchOptions = useCallback(
        ({ text }) => dispatch(FuzzyActions.getFuzzyCompaniesCampaigns({ text, idCampaign })),
        [dispatch, idCampaign],
    );

    return (
        <div className="campaign-detail-owner-filter">
            <SelectFuzzy
                label={getLiteral('label_campaigns_detail_filter_account')}
                labelMode="horizontal"
                list="empresas"
                field="nombre"
                onChange={handleChange}
                onFetchOptions={fetchOptions}
                value={value}
                isFullWidth={false}
            />
        </div>
    );
});

CampaignDetailAccountFilter.displayName = 'CampaignDetailAccountFilter';

CampaignDetailAccountFilter.propTypes = {
    data: PropTypes.array,
    idCampaign: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    owner: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CampaignDetailAccountFilter;
